export const SupportInformation = {
  email: 'support@esyn.se',
  phone: '+46(0)8-121 508 58',
  bankIdSupport: 'https://support.bankid.com/sv',
};
